import { render, staticRenderFns } from "./invoice-wizard-email-button.vue?vue&type=template&id=7c37ddc2&"
import script from "./invoice-wizard-email-button.vue?vue&type=script&lang=js&"
export * from "./invoice-wizard-email-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports